
const isInternalRegex = new RegExp("^(?:66\\.162\\.136|10|192\\.168|^172\\.(?:1[6-9]|2[0-9]|3[0-1]))\\.");

export default function isInternal(e) {
    return isInternalRegex.test(e);
}
